import { NOTIFICATION } from '../../reduxs'

export const openAndCloseToast = () => {
  return (dispatch) => {
    dispatch(_openNotification())

    setTimeout(() => {
      dispatch(_closeNotification())
      dispatch(setNotificationData(null))
    }, 10000)
  }
}

export const setNotificationData = (payload) => (dispatch) => {
  dispatch({ type: NOTIFICATION.actionType.NOTIFICATION_DATA, data: { payload } })
}

export const toggleNotification = (isOpenToastNotification) => (dispatch) => {
  dispatch({ type: NOTIFICATION.actionType.TOGGLE_NOTIFICATION, data: { isOpenToastNotification } })
}

const _closeNotification = () => dispatch => {
  dispatch({ type: NOTIFICATION.actionType.TOGGLE_NOTIFICATION, data: { isOpenToastNotification: false }})
}
const _openNotification = () => dispatch => {
  dispatch({ type: NOTIFICATION.actionType.TOGGLE_NOTIFICATION, data: { isOpenToastNotification: true }})
}
